// extracted by mini-css-extract-plugin
export default {"clickable":"CLAvatar_clickable__dG5Dn"};